<template>
    <div id="content-wrapper" class="container-fluid app-position">
        <div class="container-fluid">
            <div class="grid grid-bleed">

                <div class="col-md-9">
                    <post :post="post" v-if="analyticsMode === false"></post>
                    <post-analytics ref="analytics" :post="post" v-if="group.can.edit && analyticsMode === true"></post-analytics>
                </div>

                <div class="col-md-3">
                    <router-link :to="{ name: 'edit-post', params: { group: this.$route.params.group, post: this.$route.params.post }}" class="btn btn-create btn-small" v-if="post.can.edit" tag="button">
                        <i class="icon ion-md-create"></i>
                    </router-link>

                    <button v-on:click.stop.prevent="openModal('copy-post')" class="btn btn-create btn-small" v-if="group.can.createPosts">
                        <i class="icon ion-md-copy"></i>
                    </button>

                    <button class="btn btn-create btn-small" v-if="post.can.edit" v-on:click.stop.prevent="toggleAnalytics">
                        <i class="icon ion-md-analytics" v-if="analyticsMode === false"></i>
                        <i class="icon ion-md-eye" v-if="analyticsMode === true"></i>
                    </button>

                    <button v-on:click.stop.prevent="openModal('delete-post')" class="btn btn-create btn-small btn-danger" v-if="post.can.edit">
                        <i class="icon ion-md-trash"></i>
                    </button>

                    <div class="modal micromodal-slide" id="copy-post" aria-hidden="true">
                        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                            <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-post-settings-title">
                                <div class="modal__content">
                                    <h3>Copy post "{{ post.title }}"</h3>
                                    <p>Are you sure you wish to copy "{{ post.title }}"?</p>
                                </div>
                                <footer class="modal__footer">
                                    <button class="btn" data-micromodal-close aria-label="Close this dialog window">Close</button>
                                    <button class="btn btn-success" v-on:click.stop.prevent="copyPost()">Copy</button>
                                </footer>
                            </div>
                        </div>
                    </div>

                    <div class="modal micromodal-slide" id="delete-post" aria-hidden="true">
                        <div class="modal__overlay" tabindex="-1" data-micromodal-close>
                            <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-post-settings-title">
                                <div class="modal__content" id="modal-new-category-content">
                                    <h3>Delete post "{{ post.title }}"</h3>
                                    <p>Are you sure you wish to delete "{{ post.title }}"?</p>
                                </div>
                                <footer class="modal__footer">
                                    <button class="btn" data-micromodal-close aria-label="Close this dialog window">Close</button>
                                    <button class="btn btn-danger" v-on:click.stop.prevent="deletePost(post.id)">Delete</button>
                                </footer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MicroModal from 'micromodal';
    export default {
        props: ['post', 'group'],
        data(){
            return {
                analyticsMode: false
            }
        },
        created() {

        },
        mounted(){
            MicroModal.init();
        },
        methods: {
            openModal(modal){
                MicroModal.show(modal);
            },
            deletePost() {
                axios.delete('/api/groups/' + this.$route.params.group + "/posts/" + this.$route.params.post).then((response) => {
                    MicroModal.close('delete-post');
                    this.$router.push({ name: 'view-group', params: { group: this.$route.params.group } });
                }, (response) => {
                    this.error = response;
                });
            },
            toggleAnalytics(){
                this.analyticsMode = this.analyticsMode ? false : true;
            },
            copyPost() {
                axios.post('/api/groups/' + this.$route.params.group + "/posts/" + this.$route.params.post + "/copy").then((response) => {
                    MicroModal.close('copy-post');
                    const post = response.data;

                    this.$router.push({ name: 'edit-post', params: { group: post.group.slug, post: post.slug }});
                }, (response) => {
                    this.error = response;
                });
            }
        }
    }
</script>

<style lang="scss">
    .reactions-form{
        margin: 40px 0 20px 0;

        .btn{
            min-width: 4rem;
            font-size: 18px;
            margin-right: 5px;

            span{
                font-size: 12px;
            }
        }
    }
</style>
